import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative mt-2 rounded-md shadow-sm" }
const _hoisted_2 = { class: "text-sm capitalize" }
const _hoisted_3 = ["value", "required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label.replace(/_/g, " ")) + " " + _toDisplayString(_ctx.required ? "*" : ""), 1),
    _createElementVNode("input", {
      type: "text",
      class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5",
      value: _ctx.formattedValue,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
      required: _ctx.required
    }, null, 40, _hoisted_3)
  ]))
}